import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TransitionGroup } from 'react-transition-group';
import { Fade, makeStyles } from '@material-ui/core';
import Absence from './absence';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  type: {
    display: 'flex',
    maxWidth: '100%',
    marginBottom: spacing(6),
    '&:last-of-type': {
      marginBottom: 0,
    },
  },
}));

const Absences = ({
  className = undefined,
  translations,
  absences = [],
  canViewAbsenceReport,
  setUsersCount,
  onEditAbsence,
  onEditAbsenceTemplate = undefined,
  onDeleteAbsence,
  onGetAbsenceUsers,
  onRemoveAbsenceUsers,
  onAddExtension,
  onEditExtension,
  onDeleteExtension,
  onGetExtensionUsers,
  onRemoveExtensionUsers,
  canAccessUserProfileCheck,
  onGoToProfilePage,
  onGoToAbsenceReport,
  onAddAbsenceUsers,
  onAddExtensionUsers,
}) => {
  const classes = useStyles();

  return (
    <TransitionGroup className={classNames(classes.root, className)}>
      {absences.map(absence => (
        <Fade key={`absence_${absence.id}`} in unmountOnExit>
          <div className={classes.type}>
            <Absence
              translations={translations}
              absence={absence}
              canViewAbsenceReport={canViewAbsenceReport}
              setUsersCount={setUsersCount}
              onEditAbsence={onEditAbsence}
              onEditAbsenceTemplate={onEditAbsenceTemplate}
              onDeleteAbsence={onDeleteAbsence}
              onGetAbsenceUsers={onGetAbsenceUsers(absence.id)}
              onRemoveAbsenceUsers={onRemoveAbsenceUsers(absence)}
              onAddExtension={onAddExtension}
              onEditExtension={onEditExtension}
              onDeleteExtension={onDeleteExtension}
              onGetExtensionUsers={onGetExtensionUsers}
              onRemoveExtensionUsers={onRemoveExtensionUsers()}
              canAccessUserProfileCheck={canAccessUserProfileCheck}
              onGoToProfilePage={onGoToProfilePage}
              onGoToAbsenceReport={onGoToAbsenceReport(absence)}
              onAddAbsenceUsers={onAddAbsenceUsers(absence)}
              onAddExtensionUsers={extension =>
                onAddExtensionUsers(absence.id)(extension)
              }
            />
          </div>
        </Fade>
      ))}
    </TransitionGroup>
  );
};

Absences.propTypes = {
  className: PropTypes.string,
  translations: PropTypes.object.isRequired,
  absences: PropTypes.arrayOf(PropTypes.object),
  canViewAbsenceReport: PropTypes.bool.isRequired,
  setUsersCount: PropTypes.number.isRequired,
  onEditAbsence: PropTypes.func.isRequired,
  onEditAbsenceTemplate: PropTypes.func,
  onDeleteAbsence: PropTypes.func.isRequired,
  onGetAbsenceUsers: PropTypes.func.isRequired,
  onRemoveAbsenceUsers: PropTypes.func.isRequired,
  onAddExtension: PropTypes.func.isRequired,
  onEditExtension: PropTypes.func.isRequired,
  onDeleteExtension: PropTypes.func.isRequired,
  onGetExtensionUsers: PropTypes.func.isRequired,
  onRemoveExtensionUsers: PropTypes.func.isRequired,
  canAccessUserProfileCheck: PropTypes.func.isRequired,
  onGoToProfilePage: PropTypes.func.isRequired,
  onGoToAbsenceReport: PropTypes.func.isRequired,
  onAddAbsenceUsers: PropTypes.func.isRequired,
  onAddExtensionUsers: PropTypes.func.isRequired,
};

export default Absences;
